import { IComponentDictionary, IErrorMessage, IComponent, EComponentTypes } from './';
import store from '../store/store';
import types from '../store/types';

export class JourneyValidationHelper {

    public static ValidateJourney(): boolean {

        // get list of components
        let components: IComponentDictionary = store.getState().processState.components;

        let errorMessages: IErrorMessage[] = [];

        // iterate list and check validity
        for(let componentId in components) {
            let component: IComponent = components[componentId];

            switch(component.ComponentType.ComponentTypeId) {
                case EComponentTypes.loop:
                    errorMessages = errorMessages.concat(JourneyValidationHelper.ValidateLoopComponent(component, components));
                    break;
                default: 
                    break;
            }
        }

        // TODO: raise any errors
        if(errorMessages && errorMessages.length) {
            store.dispatch({
                type: types.RAISE_ERROR,
                error: {
                    code: -1,
                    message: "Journey Save Operation Failed",
                    errorMessages: errorMessages
                }
            });
        }

        return !errorMessages.length;

    }

    private static ValidateLoopComponent(loopComponent: IComponent, components: IComponentDictionary): IErrorMessage[] {

        let currentComponentId: string = loopComponent.Loop.FirstLoopComponent ? 
            loopComponent.Loop.FirstLoopComponent.ComponentId : null;

        while(currentComponentId) {

            let component: IComponent = components[currentComponentId];

            if(component) {
                if(component.ControlBlock && component.ControlBlock.Controls && component.ControlBlock.Controls.length) {
                    return [];

                }                
                currentComponentId = component.NextComponent ? component.NextComponent.ComponentId : null;
            }
            else {
                currentComponentId = null;
            }

        }

        return [{
            componentId: loopComponent.Id,
            errorType: null,
            message: "A loop component must contain at least one control block that has at least one control."
        }];

    }

}


// WEBPACK FOOTER //
// ./source/ts/helpers/journey-validation.ts